
export default (axios) => ({
  getDashboardAnalytics(payload) {
    return axios.post("/dashboard", payload)
  }
})